import React from 'react';
import { Tag, Badge } from 'antd';
import { TagOutlined, CheckCircleOutlined } from '@ant-design/icons';

const ServiceDetailsSection = ({ service }) => {
  return (
    <div className="card property_list">
      <div className="body">
        <div className="property-content">
          <div className="detail">
            <div className="text-success m-t-0 m-b-0">
              {service.category && service.category.map((cat, index) => (
                <Tag color="blue" key={index} icon={<TagOutlined />}>
                  {cat}
                </Tag>
              ))}
            </div>
            <h4 className="m-t-0">
              <a href="#" className="col-blue-grey">{service.name}</a>
            </h4>
            <p className="text-muted">
              <i className="zmdi zmdi-pin m-r-5" />{service.address}
            </p>
            <p className="text-muted m-b-0">{service.description}</p>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '20px', marginTop: '20px' }}>
            {service.activities && service.activities.map((activity, index) => (
              <Badge
                count={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
                key={index}
                style={{ backgroundColor: '#fafafa' }}
                overflowCount={999}
              >
                <span style={{ padding: '5px 10px', background: '#f0f2f5', borderRadius: '4px' }}>
                  {activity}
                </span>
              </Badge>
            ))}
            {service.beneficiaries && service.beneficiaries.map((activity, index) => (
              <Badge
                count={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
                key={index}
                style={{ backgroundColor: '#fafafa' }}
                overflowCount={999}
              >
                <span style={{ padding: '5px 10px', background: '#f0f2f5', borderRadius: '4px' }}>
                  {activity}
                </span>
              </Badge>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceDetailsSection; 